import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { InspectionPoint } from './inspection-point';
import { DrawingInspectionPointData } from './drawing-inspection-point-data';

export class DrawingEquipmentData implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Drawing Equipment Data';
  readonly apiRoute: string = CONFIG.apiRoutes.inspectionPointEquipmentData;

  mediaItemDetailsId: string;
  orgTreeNodeName: string;
  criticality: string;
  criticalityColor: string;
  inspectionPointData: DrawingInspectionPointData[] = [];
  selectedInspectionPoints: InspectionPoint[] = [];

  public json(): any {
    return this;
  }

  public loadFromJson(data: any): void {
    this.mediaItemDetailsId = data.mediaItemDetailsId;
    this.orgTreeNodeName = data.orgTreeNodeName;
    this.criticality = data.criticality;
    this.criticalityColor = data.criticalityColor;

    this.inspectionPointData = [];

    if (data.inspectionPointData) {
      data.inspectionPointData.forEach(inspectionPointData => {
        const newInspectionPointData = new DrawingInspectionPointData();
        newInspectionPointData.loadFromJson(inspectionPointData);
        this.inspectionPointData.push(newInspectionPointData);
      });
    }

    this.selectedInspectionPoints = [];

    if (data.selectedInspectionPoints) {
      data.selectedInspectionPoints.forEach(inspectionPoint => {
        const newInspectionPoint = new InspectionPoint();
        newInspectionPoint.loadFromJson(inspectionPoint);
        this.selectedInspectionPoints.push(newInspectionPoint);
      });
    }
  }
}
